import React, { useEffect, useState } from "react";

// Top-of-page scroll progress bar (thin gold accent)
const ScrollProgress = () => {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const update = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setPct(max > 0 ? Math.min(100, (h.scrollTop / max) * 100) : 0);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <div className="fixed top-0 inset-x-0 z-[60] h-[3px] pointer-events-none">
      <div
        className="h-full bg-gradient-to-r from-knight-navy via-knight-navy-light to-knight-gold transition-[width] duration-150"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

export default ScrollProgress;
